import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { PreJoin } from '@features/Remote/PreJoin';
import { AppointmentParticipantType } from '@generated/gql/graphql';
import { useLoader } from '@hooks/useLoader';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { RequestState } from '@src/types/index';

const RemotePreJoin = () => {
  const {
    appointment,
    loading: appointmentLoading,
    session,
  } = useAppointmentContext();
  const title =
    session.userType === AppointmentParticipantType.Partner
      ? 'Set up your appointment'
      : 'Get ready for your appointment';
  const navigate = useNavigate();
  const { setRequestState } = useLoader();
  useEffect(() => {
    setRequestState(
      appointmentLoading ? RequestState.loading : RequestState.success
    );
  }, [setRequestState, appointmentLoading]);

  if (!appointment?.id && !appointmentLoading) {
    navigate(paths.partner);
    return null;
  }

  return (
    <Layout title={title}>
      <PreJoin />
    </Layout>
  );
};

export { RemotePreJoin };
